import { LoadingSpinner } from '~/components/LoadingSpinner';
import { useFeatureFlag, useFeatureFlagStatus } from '~/features/feature-flags/useFeatureFlag';
import { ListingSearchPane } from './ListingSearchPane';
import { ListingSearchTabs } from './ListingSearchTabs';

// [MCV-1889] With the flag off the page is the Selling search alone, exactly as it was. With it on,
// a Buying | Selling control sits above two independent searches.
export const ListingSearch = () => {
  const offeringEnabled = useFeatureFlag('b2bOfferingListings');
  // The flag reads false until it loads; mounting the Selling pane then swapping to the tabs would
  // run its search twice.
  const flagStatus = useFeatureFlagStatus();
  if (flagStatus === 'loading') return <LoadingSpinner />;
  return offeringEnabled ? <ListingSearchTabs /> : <ListingSearchPane side="SEEKING" />;
};
